import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    remitterListData: [],
    remitterDetailByRemitterId: {},
    remitterId: null,
    remitterRelation: null,
    selectedRemitterIdFromRemitterType: null,
    remitterInsertedData: {},
    loading: false,
    error: null
};

export const remitterSlice = createSlice({
    name: 'remitter',
    initialState,
    reducers: {
        remitterListSuccess: (state, action) => {
            state.remitterListData = action.payload;
            state.loading = false;
            state.error = null;
        },
        remitterDetailSuccess: (state, action) => {
            state.remitterDetailByRemitterId = action.payload;
            state.loading = false;
            state.error = null;
        },
        remitterListFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        remitterReset: () => initialState,
        remitterLoading: (state) => {
            state.loading = true;
            state.error = null;
        },
        remitterError: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        remitterInsertSuccess: (state, action) => {
            state.remitterInsertedData = action.payload;
            state.loading = false;
            state.error = null;
        },
        remitterRelationSuccess: (state, action) => {
            state.remitterRelation = action.payload;
            state.loading = false;
            state.error = null;
        },
        remitterInsertReset: (state) => {
            state.remitterInsertedData = {};
            state.loading = false;
            state.error = null;
        },
        selectRemitterId: (state, action) => {
            console.log('Saving Remitter ID:', action.payload);
            state.remitterId = action.payload;
        },
        remitterTypeIdSuccess: (state, action) => {
            state.selectedRemitterIdFromRemitterType = action.payload;
        }
    }
});

export const {
    remitterListSuccess,
    remitterDetailSuccess,
    remitterListFailure,
    remitterReset,
    remitterLoading,
    remitterError,
    remitterInsertSuccess,
    remitterInsertReset,
    remitterTypeIdSuccess,
    remitterRelationSuccess
} = remitterSlice.actions;

export default remitterSlice.reducer;
